module.exports = require("core-js/library/fn/object/define-property");


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime-corejs2@7.17.7@@babel/runtime-corejs2/core-js/object/define-property.js
// module id = ixlO
// module chunks = 16